import { render, staticRenderFns } from "./FormPenilaianJasmani.vue?vue&type=template&id=54b48b3a"
import script from "./FormPenilaianJasmani.vue?vue&type=script&lang=js"
export * from "./FormPenilaianJasmani.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports